import { Link } from 'gatsby';

export const Button = ({ className, children, to, ...restProps }) => {
  if (to) {
    return (
      <Link
        className={['button', className].filter(Boolean).join(' ')}
        to={to}
        {...restProps}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      className={['button', className].filter(Boolean).join(' ')}
      {...restProps}
    >
      {children}
    </button>
  );
};
